import React, { useState } from 'react';
import { CategoryLabel } from '../../../_lib/components/CategoryLabel';
import { ContentHeadline } from '../../../_lib/components/ContentHeadline';
import { ContentParagraph, ContentParagraphModifier } from '../../../_lib/components/ContentParagraph';
import bem from '../../../lib/bemUtils/bem';
import { ImageModifier } from '../../../components/molecules/Image';
import { LinkedTeaserImage } from '../../../components/molecules/LinkedTeaserImageInLists';
import { ParticipationButton } from '../../../_lib/components/ParticipationButton';
import { PagePackState } from '../../../types/api/PagePackState';
import { Event } from '../EventListDetails.types';
import { EventTileDate } from './EventTileDate';
import { formatDate, TimeFormats } from '../../../lib/DateFormat';

type EventListTileItemProps = {
  event: Event;
};

export function EventListTileItem({ event }: EventListTileItemProps) {
  const hexColor = event.categories?.at(0)?.hexColor;
  const hasCategoryBorder = Boolean(hexColor);
  const showDateBadge = Boolean(event.eventStartDate);
  const badgeSitsOnCard = !event.teaserImage && showDateBadge;
  const [currentParticipating, setCurrentParticipating] = useState(event.participant ?? false);

  return (
    <div
      className={bem('event-list-tiles__item', [hasCategoryBorder && 'category-border', badgeSitsOnCard && 'no-image'])}
      style={hexColor ? { borderLeftColor: hexColor } : undefined}
    >
      {showDateBadge && (
        <span className="event-list-tiles__date-badge font-bold-15-15" aria-hidden="true">
          {formatDate(event.eventStartDate, TimeFormats.DAY_MONTH_YEAR_SHORT)}
        </span>
      )}
      {event.teaserImage && (
        <div className="event-list-tiles__image">
          <LinkedTeaserImage
            imageSrc={event.teaserImage.url}
            pageLink={event.pageLink.url}
            modifier={ImageModifier.WIDTH_HEIGHT_100}
          />
        </div>
      )}
      <div className="event-list-tiles__content">
        <CategoryLabel className="event-list-tiles__category font-regular-13-13" categories={event.categories} />
        <ContentHeadline
          title={event.pageLink.name}
          url={event.pageLink.url}
          hierarchy={3}
          stateIndicatorStatus={event.packState === PagePackState.ONLY_DRAFT_VERSION ? 'red' : undefined}
        />
        {event.teaserText && (
          <ContentParagraph modifier={ContentParagraphModifier.MARGIN_BOTTOM}>{event.teaserText}</ContentParagraph>
        )}
        <EventTileDate event={event} />
        {event.joinForm && event.leaveForm && (
          <div className="event-list-tiles__participation">
            <ParticipationButton
              form={currentParticipating ? event.leaveForm : event.joinForm}
              participating={currentParticipating}
              onSuccess={() => setCurrentParticipating(prev => !prev)}
            />
          </div>
        )}
      </div>
    </div>
  );
}
